import { useEffect, useState, useCallback } from 'react';
import { useAppContext } from 'hooks/useAppContext';
import { getResources } from 'utils/ResourcesUtils';


const useResources = () => {
    const [ resources, setResources ] = useState([]);
    const { selectedProject } = useAppContext();

    useEffect(() => {
        let mounted = true;
        const asyncEffect = async () => {
            const filters = [{"defaults":{"projectId": selectedProject,"IsActive":true}}]
            const resources = await getResources(undefined, undefined, undefined, undefined, undefined, filters);
            if(resources.data) {
                mounted && setResources(resources.data);
            } else {
                console.error('unabled to fetch resources');
                return [];
            }
        }
        mounted && asyncEffect();
        return () => {mounted = false};
    }, [selectedProject]);

    const searchResources = useCallback((val) => {
        return resources ? resources.filter(r => r.Name_SystemUser.toLowerCase().search(val.toLowerCase()) > -1) : '';
    }, [resources]);

    const findResourceByName = useCallback((name) => {
        return resources.find(r => r.Name_SystemUser === name) ? resources.find(r => r.Name_SystemUser === name).SystemUserId_SystemUser : null
    }, [resources]);

    return {resources, searchResources, findResourceByName};
}

export default useResources;